import { useCallback } from 'react'

import { getTrackingDocumentType } from '@features/invoices/utils/getTrackingDocumentType'

import { useSegment } from '../../../../../hooks'
import { useInvoice } from '../contexts/invoiceContext'

export const useTrackInvoiceView = () => {
  const { track } = useSegment()
  const { invoice, documentType } = useInvoice()

  const trackInvoiceView = useCallback(
    (eventDetail: string, payload?: Record<string, any>) => {
      const invoiceStatus = invoice?.status?.status
      const trackingDocumentType = getTrackingDocumentType({ billingStage: invoice?.billingStage, documentType })

      track(`XXX - Invoicing Core - Invoice View - ${eventDetail}`, {
        ...payload,
        documentType: trackingDocumentType,
        invoiceStatus,
      })
    },
    [documentType, invoice, track],
  )

  return { trackInvoiceView }
}
